import { Action } from '@ngrx/store';
import {
  Fund,
  TransactionsData,
  TransactionsDetailsRequestPayload,
  TransactionsDetailsResponsePayload,
  TransactionsExportRequestPayload,
  TransactionsFilter,
  TransactionsRequestPayload,
} from './transactions.models';
import { DatesInterval, DatesIntervalRequest } from '../../global/interfaces';

import { PaginationInfo } from 'atlas-pagination';

export enum ActionTypes {
  LOAD_TRANSACTIONS_DATES = '[Transactions] Load Transactions Dates Action',
  LOAD_TRANSACTIONS_DATES_SUCCESS = '[Transactions] Load Transactions Dates Success Action',
  LOAD_TRANSACTIONS_DATES_FAILED = '[Transactions] Load Transactions Dates Failed Action',

  LOAD_TRANSACTIONS = '[Transactions] Load Account Transactions Action',
  LOAD_TRANSACTIONS_SUCCESS = '[Transactions] Load Account Transactions Success Action',
  LOAD_TRANSACTIONS_FAILED = '[Transactions] Load Account Transactions Failed Action',

  LOAD_TRANSACTIONS_FOR_PDF = '[Transactions] Load Account Transactions For PDF Action',
  LOAD_TRANSACTIONS_FOR_PDF_SUCCESS = '[Transactions] Load Account Transactions For PDF Success Action',
  LOAD_TRANSACTIONS_FOR_PDF_FAILED = '[Transactions] Load Account Transactions For PDF Failed Action',

  LOAD_TRANSACTIONS_DETAILS = '[Transactions] Load Account Transactions Details Action',
  LOAD_TRANSACTIONS_DETAILS_SUCCESS = '[Transactions] Load Account Transactions Details Success Action',
  LOAD_TRANSACTIONS_DETAILS_FAILED = '[Transactions] Load Account Transactions Details Failed Action',

  EXPORT_TRANSACTIONS_DETAILS = '[Transactions] Export Account Transactions Details Action',

  LOAD_TRANSACTIONS_MOBILE = '[Transactions] Load Account Transactions Mobile Data Action',
  LOAD_TRANSACTIONS_MOBILE_SUCCESS = '[Transactions] Load Account Transactions Mobile Data Success Action',
  LOAD_TRANSACTIONS_MOBILE_FAILED = '[Transactions] Load Account Transactions Mobile Data Failed Action',

  SET_TRANSACTIONS_MOBILE_PAGINATION = '[Transactions] Set Transactions Mobile Pagination',
  RESET_TRANSACTIONS_MOBILE_PAGINATION = '[Transactions] Reset Transactions Mobile Pagination',
  RESET_TRANSACTIONS_MOBILE = '[Transactions] Reset Transactions Mobile Data',

  SET_TRANSACTIONS_FILTER = '[Transactions] Set Transactions Filter Action',
  SET_TRANSACTIONS_FILTER_FUNDS = '[Transactions] Set Transactions Filter Funds Action',
  SET_TRANSACTIONS_FILTER_FROM = '[Transactions] Set Transactions Filter From Action',
  SET_TRANSACTIONS_FILTER_TO = '[Transactions] Set Transactions Filter To Action',

  EXPORT_TRANSACTIONS_REPORT = '[Transactions] Export Transactions Report',

  RESET_TRANSACTIONS_DATA = '[Transactions] Reset Transactions Data Action',
  RESET_TRANSACTIONS_FILTER = '[Transactions] Reset Transactions Filter Action',
  SET_TRANSACTIONS_DETAILS_PAGINATION = '[Transactions] Reset Transactions Details Pagination Action',

}

/**
 * Dates
 */
export class LoadTransactionsDatesAction implements Action {
  readonly type = ActionTypes.LOAD_TRANSACTIONS_DATES;

  public constructor(public payload: DatesIntervalRequest) {
  }
}

export class LoadTransactionsDatesSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_TRANSACTIONS_DATES_SUCCESS;

  public constructor(public payload: DatesInterval) {
  }
}

export class LoadTransactionsDatesFailedAction implements Action {
  readonly type = ActionTypes.LOAD_TRANSACTIONS_DATES_FAILED;

  public constructor(public payload: any) {
  }
}

/**
 * Data
 */
export class LoadTransactionsAction implements Action {
  readonly type = ActionTypes.LOAD_TRANSACTIONS;

  public constructor(public payload: TransactionsRequestPayload) {
  }
}

export class LoadTransactionsSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_TRANSACTIONS_SUCCESS;

  public constructor(public payload: TransactionsData[]) {
  }
}

export class LoadTransactionsFailedAction implements Action {
  readonly type = ActionTypes.LOAD_TRANSACTIONS_FAILED;

  public constructor(public payload: any) {
  }
}

/**
 * Data for PDF
 */
export class LoadTransactionsForPDFAction implements Action {
  readonly type = ActionTypes.LOAD_TRANSACTIONS_FOR_PDF;

  public constructor(public payload: TransactionsRequestPayload) {
  }
}

export class LoadTransactionsForPDFSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_TRANSACTIONS_FOR_PDF_SUCCESS;

  public constructor(public payload: TransactionsData[]) {
  }
}

export class LoadTransactionsForPDFFailedAction implements Action {
  readonly type = ActionTypes.LOAD_TRANSACTIONS_FOR_PDF_FAILED;

  public constructor(public payload: any) {
  }
}

/**
 * Details page (desktop)
 */
export class LoadTransactionsDetailsAction implements Action {
  readonly type = ActionTypes.LOAD_TRANSACTIONS_DETAILS;

  public constructor(public payload: TransactionsDetailsRequestPayload) {
  }
}

export class LoadTransactionsDetailsSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_TRANSACTIONS_DETAILS_SUCCESS;

  public constructor(public payload: TransactionsDetailsResponsePayload) {
  }
}

export class LoadTransactionsDetailsFailedAction implements Action {
  readonly type = ActionTypes.LOAD_TRANSACTIONS_DETAILS_FAILED;

  public constructor(public payload: any) {
  }
}

export class ExportTransactionsDetailsAction implements Action {
  readonly type = ActionTypes.EXPORT_TRANSACTIONS_DETAILS;

  public constructor(public payload: TransactionsExportRequestPayload) {
  }
}

/**
 * Data (mobile)
 */
export class LoadTransactionsMobileAction implements Action {
  readonly type = ActionTypes.LOAD_TRANSACTIONS_MOBILE;

  public constructor(public payload: TransactionsDetailsRequestPayload) {
  }
}

export class LoadTransactionsMobileSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_TRANSACTIONS_MOBILE_SUCCESS;

  public constructor(public payload: TransactionsDetailsResponsePayload) {
  }
}

export class LoadTransactionsMobileFailedAction implements Action {
  readonly type = ActionTypes.LOAD_TRANSACTIONS_MOBILE_FAILED;

  public constructor(public payload: any) {
  }
}

export class SetTransactionsMobilePagination implements Action {
  public readonly type = ActionTypes.SET_TRANSACTIONS_MOBILE_PAGINATION;

  public constructor(public payload: PaginationInfo) {
  }
}

export class ResetTransactionsMobilePagination implements Action {
  public readonly type = ActionTypes.RESET_TRANSACTIONS_MOBILE_PAGINATION;
}

export class ResetTransactionsMobileData implements Action {
  public readonly type = ActionTypes.RESET_TRANSACTIONS_MOBILE;
}

/**
 * Filters
 */
export class SetTransactionsFilterAction implements Action {
  readonly type = ActionTypes.SET_TRANSACTIONS_FILTER;

  public constructor(public payload: TransactionsFilter) {
  }
}

export class SetTransactionsFilterFundsAction implements Action {
  readonly type = ActionTypes.SET_TRANSACTIONS_FILTER_FUNDS;

  public constructor(public payload: Fund[]) {
  }
}

export class SetTransactionsFilterFromAction implements Action {
  readonly type = ActionTypes.SET_TRANSACTIONS_FILTER_FROM;

  public constructor(public payload: string) {
  }
}

export class SetTransactionsFilterToAction implements Action {
  readonly type = ActionTypes.SET_TRANSACTIONS_FILTER_TO;

  public constructor(public payload: string) {
  }
}

/**
 * Export PDF
 */
export class ExportTransactionsReportAction implements Action {
  readonly type = ActionTypes.EXPORT_TRANSACTIONS_REPORT;

  public constructor(public payload: any) {
  }
}

/**
 * Reset data
 */
export class ResetTransactionsDataAction implements Action {
  readonly type = ActionTypes.RESET_TRANSACTIONS_DATA;
}

export class ResetTransactionsFilterAction implements Action {
  readonly type = ActionTypes.RESET_TRANSACTIONS_FILTER;
}
export class SetTransactionsDetailsPaginationAction implements Action {
  readonly type = ActionTypes.SET_TRANSACTIONS_DETAILS_PAGINATION;

  public constructor(public payload: PaginationInfo) {
  }
}

export type Actions =
  LoadTransactionsDatesAction |
  LoadTransactionsDatesSuccessAction |
  LoadTransactionsDatesFailedAction |
  LoadTransactionsAction |
  LoadTransactionsSuccessAction |
  LoadTransactionsFailedAction |
  LoadTransactionsForPDFAction |
  LoadTransactionsForPDFSuccessAction |
  LoadTransactionsForPDFFailedAction |
  SetTransactionsFilterAction |
  SetTransactionsFilterFundsAction |
  SetTransactionsFilterFromAction |
  SetTransactionsFilterToAction |
  LoadTransactionsDetailsAction |
  LoadTransactionsDetailsSuccessAction |
  LoadTransactionsDetailsFailedAction |
  ExportTransactionsDetailsAction |
  LoadTransactionsMobileAction |
  LoadTransactionsMobileSuccessAction |
  LoadTransactionsMobileFailedAction |
  SetTransactionsMobilePagination |
  ResetTransactionsMobilePagination |
  ResetTransactionsMobileData |
  ExportTransactionsReportAction |
  ResetTransactionsDataAction |
  ResetTransactionsFilterAction |
  SetTransactionsDetailsPaginationAction;
